'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  tr: _styledComponents2.default.tr.withConfig({
    displayName: 'TableRow__tr'
  })(['@media print{page-break-inside:avoid;}'])
},
    TableRow = function (_Component) {
  function TableRow(props) {
    _classCallCheck(this, TableRow);

    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    return _this.state = {
      hover: !1
    }, _this.handleMouseEnter = _this.handleMouseEnter.bind(_this), _this.handleMouseLeave = _this.handleMouseLeave.bind(_this), _this;
  }

  return _inherits(TableRow, _Component), _createClass(TableRow, [{
    key: 'handleMouseEnter',
    value: function handleMouseEnter() {
      this.setState({
        hover: !0
      });
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      this.setState({
        hover: !1
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          children = _react2.default.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          rowHover: _this2.state.hover
        });
      });

      return _react2.default.createElement(Styled.tr, {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, children);
    }
  }]), TableRow;
}(_react.Component);

TableRow.propTypes = {
  children: _propTypes2.default.node
}, TableRow.defaultProps = {}, TableRow.displayName = 'TableRow', exports.default = TableRow;